import { TApiResponse } from '@/common/types/response';

import { TPersonalAccountCochairState } from './types';

export function setListOfCountry(
  state: TPersonalAccountCochairState,
  res: TApiResponse<TPersonalAccountCochairState['listOfCountry']>,
) {
  state.listOfCountry = res.data;

  state.isLoading = false;
}

export function setMoreListOfCountry(
  state: TPersonalAccountCochairState,
  res: TApiResponse<TPersonalAccountCochairState['listOfCountry']>,
) {
  state.listOfCountry = {
    ...state.listOfCountry,
    firstItemNumber: res.data.firstItemNumber,
    items: state.listOfCountry.items.concat(res.data.items),
    pageNumber: res.data.pageNumber
  }

  state.isLoadingMore = false;
}

export function setIsLoading(state: TPersonalAccountCochairState, isLoading: boolean) {
  state.isLoading = isLoading;
}

export function setIsLoadingMore(state: TPersonalAccountCochairState, isLoading: boolean) {
  state.isLoadingMore = isLoading;
}
